export const mbToBytes = (mb) => mb * 1024 * 1024;
